module.exports = __webpack_public_path__ + "img/dashboard-active.ec156664.svg";